import React from "react";
import { Button as ButtonStyle } from "./style";
import { withTheme } from "../../../hoc";

export const Button = (props) => (
  <ButtonStyle {...props}>
    {props.icon ? <span>{props.icon}</span> : ""}
    {props.children}
  </ButtonStyle>
);
export default withTheme(Button);
